export const config = {
  API_BASE_URL: process.env.REACT_APP_API_URL || 'https://api.ligchat.com/api',
  WHATSAPP_API_URL: process.env.REACT_APP_WEBSOCKET_URL || 'https://whatsapp.ligchat.com',
};